// FÁZE 5 — Stat Battle: kdo měl více? Souboj statistik dvou hráčů.
import React, { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { Sword } from "@phosphor-icons/react";
import AppShell from "../components/AppShell";
import { useAuth } from "../contexts/AuthContext";
import { funDuel, funResult } from "../lib/lab-api";

export default function StatBattle() {
    const { user } = useAuth();
    const [round, setRound] = useState(null);
    const [revealed, setRevealed] = useState(false);
    const [pick, setPick] = useState(null);
    const [score, setScore] = useState({ correct: 0, total: 0, streak: 0 });

    const next = useCallback(() => {
        setRevealed(false); setPick(null);
        funDuel({ count: 2 }).then(setRound).catch(() => toast.error("Načtení kola selhalo"));
    }, []);
    useEffect(() => { next(); }, [next]);

    const answer = async (i) => {
        if (revealed || !round) return;
        setPick(i);
        setRevealed(true);
        const vals = round.players.map((p) => Number(p.value));
        const correct = vals[i] > vals[1 - i];
        setScore((s) => ({ correct: s.correct + (correct ? 1 : 0), total: s.total + 1, streak: correct ? s.streak + 1 : 0 }));
        if (user) {
            try { await funResult("stat_battle", correct); } catch { /* ignore */ }
        }
    };

    return (
        <AppShell>
            <div className="max-w-3xl mx-auto space-y-6" data-testid="stat-battle-page">
                <header className="text-center">
                    <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-fa-yellow">Fun · Stat Battle</div>
                    <h1 className="font-display font-black uppercase text-2xl md:text-3xl mt-1 flex items-center justify-center gap-2">
                        <Sword size={24} className="text-fa-yellow" /> Kdo měl více?
                    </h1>
                    <div className="font-mono text-[10px] text-white/50 mt-2" data-testid="stat-battle-score">
                        Skóre {score.correct}/{score.total} · streak {score.streak}
                        {user ? " · správně = +1 Knowledge XP" : " · přihlas se a sbírej Knowledge XP"}
                    </div>
                </header>
                {round && (
                    <>
                        <div className="text-center font-display font-black text-lg text-fa-cream" data-testid="stat-battle-question">
                            Kdo měl více: {round.stat.label}?
                        </div>
                        <div className="grid grid-cols-2 gap-3">
                            {round.players.map((p, i) => {
                                const vals = round.players.map((x) => Number(x.value));
                                const winner = vals[i] > vals[1 - i];
                                return (
                                    <button key={p.fpl_id} type="button" onClick={() => answer(i)} data-testid={`stat-battle-pick-${i}`}
                                            className={`border p-6 text-center transition-colors ${revealed
                                                ? winner ? "border-fa-mint bg-fa-mint/10" : pick === i ? "border-red-400 bg-red-500/10" : "border-white/10"
                                                : "border-white/15 bg-black/40 hover:border-fa-yellow/60 cursor-pointer"}`}>
                                        <div className="font-display font-black text-xl">{p.name}</div>
                                        <div className="font-mono text-[10px] uppercase text-white/45 mt-1">{p.team} · {p.position} · £{p.price}</div>
                                        <div className={`font-display font-black text-3xl mt-3 tabular-nums ${revealed ? (winner ? "text-fa-mint" : "text-white/40") : "text-white/20"}`}
                                             data-testid={`stat-battle-value-${i}`}>
                                            {revealed ? p.value : "?"}
                                        </div>
                                    </button>
                                );
                            })}
                        </div>
                        {revealed && (
                            <div className="text-center">
                                <button type="button" onClick={next} data-testid="stat-battle-next"
                                        className="font-mono text-xs uppercase tracking-widest px-6 py-3 bg-fa-yellow text-black font-bold">
                                    Další kolo →
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </AppShell>
    );
}
